// extracted by mini-css-extract-plugin
export default {"signup-group-form":"styles__signup-group-form____cv8W","half-width-left":"styles__half-width-left____Fzxv","readOnly":"styles__readOnly___GK2Wq"};